import React from "react";
import { Gift, TrendingUp, LineChart, Zap } from "lucide-react";
import { bonuses, PURCHASE_URL } from "../mock";

const icons = [TrendingUp, LineChart, Zap];

const Bonuses = () => {
  return (
    <section className="relative py-20 px-4">
      <div className="mx-auto max-w-6xl">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-4 py-1.5">
            <Gift className="h-4 w-4 text-emerald-400" />
            <span className="text-[11px] font-bold tracking-[0.25em] text-emerald-400">
              COMPLIMENTARY BONUS
            </span>
          </div>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-white">
            3 Free Chartink Scanners
          </h2>
          <p className="mt-3 text-slate-400">
            Combined worth{" "}
            <span className="text-emerald-400 font-bold">₹15,000</span> — yours
            free with every Swift-AI Indicator purchase.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {bonuses.map((b, i) => {
            const Icon = icons[i];
            return (
              <div
                key={b.title}
                className="group relative rounded-2xl border border-slate-700/60 bg-slate-900/40 p-6 backdrop-blur transition-all duration-300 hover:-translate-y-1 hover:border-sky-400/60 hover:shadow-[0_0_30px_rgba(59,130,246,0.2)]"
              >
                <div className="flex items-center justify-between">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-sky-500/20 to-blue-600/20 border border-sky-500/30">
                    <Icon className="h-5 w-5 text-sky-400" />
                  </div>
                  <span className="text-xs font-bold text-emerald-400 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-3 py-1">
                    Worth {b.worth}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-bold text-white">{b.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                  {b.desc}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href={PURCHASE_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-sky-500 to-blue-600 px-8 py-3.5 font-bold text-white tracking-wider text-sm shadow-[0_0_40px_rgba(59,130,246,0.4)] transition-transform duration-300 hover:scale-[1.03]"
          >
            <Gift className="h-4 w-4" />
            CLAIM BONUS + INDICATOR
          </a>
        </div>
      </div>
    </section>
  );
};

export default Bonuses;
